// extracted by mini-css-extract-plugin
export var hidden = "_sl-0";